import React from 'react'
import { Redirect } from 'react-router-dom'

import { Routes } from '../../navigation/config/routes'

export const VoiceAgentCalls: React.FC = () => (
    <Redirect to={`${Routes.manage.voiceAgent.root}?tab=calls`} />
)
